import Switch from '@mui/material/Switch';
import React from 'react';
import { styled } from '@mui/material/styles';

const StyledSwitch = styled(Switch)(() => ({
  width: 54,
  height: 34,
  padding: 6,
  '& .Mui-checked': {
    color: '#fff !important',
  },
  '& .Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#199da3 !important',
    opacity: '1 !important',
  },
  '& .MuiSwitch-track': {
    borderRadius: 12,
    backgroundColor: '#c9ced6',
  },
  '& .MuiSwitch-thumb': {
    width: 16,
    height: 16,
    boxShadow: 'unset',
  },
}));

const UiSwitch = (props) => {
  return <StyledSwitch {...props} />;
};

export default UiSwitch;
